export default "__VITE_ASSET__CayNsp$I__"